export enum NoteType {
  Lead = 'lead',
  Update = 'update',
  Client = 'client',
}

export interface Note<T = NoteType> {
  body: string;
  createdByGuid: string;
  createdBy: {
    email: string;
    guid: string;
    name: string;
  };
  dateCreated: string;
  guid: string;
  isBroadcast: boolean;
  type: T;
  title: string | null;
  isClientNote?: boolean;
}
